import axios from "axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IAIContentRequest, IAIContentResponseDto } from "../interfaces/endpoints/IAIContent";

export const generateAIContent = async (
  data: IAIContentRequest
): Promise<IAxiosResponse<IAIContentResponseDto>> => {
  return axios.post<IAIContentResponseDto>("/AIContent/generate", data);
};
